$(function() {

    handleDebugParameter();
    handleNoScroll();
    setupNavGlider();
    handleGoToHub();
    setupScrollAnimations();
    setupTrustScroll();
    setupCapabilitiesScroll();
    setupShowcaseScroll();
    handleNbParameter();

    if (!pageInfo.debug && (typeof quicklink !== 'undefined')) {
        quicklink.listen({
            timeout: 1000,
            ignores: [
                function(uri) { return uri.includes('wp-') || uri.includes('login') || uri.includes('logout') || uri.includes('register'); },
                function(uri, elem) { return elem.hasAttribute('noprefetch'); }
              ]
        });
    }

    $('#account_username').on('input', function() {

        var val = $(this).val();

        // Replace all uppercase letters with lowercase
        val = val.toLowerCase();

        // Remove all non-alphanumeric lowercase characters, dashes and underscores
        val = val.replace(/(--|__|-_|_-)|[^a-z0-9-_]/g, '');

        // Remove all leading dashes and underscores
        val = val.replace(/^[-_]+/g, '');

        $(this).val(val);

    });

    $('#lwa_user_login').on('input', function() {
        var c = this.selectionStart,
            r = /(--|__|-_|_-)|[^a-z0-9-_]/g,
            v = $(this).val();
        if(r.test(v)) {
          $(this).val(v.replace(r, ''));
          c--;
        }
        this.setSelectionRange(c, c);
      });

      $('#user_login').on('input', function() {
        var c = this.selectionStart,
            r = /(--|__|-_|_-)|[^a-z0-9-_]/g,
            v = $(this).val();
        if(r.test(v)) {
          $(this).val(v.replace(r, ''));
          c--;
        }
        this.setSelectionRange(c, c);
      });

    $("#easy-start-windows-btn").on('click', function(){
        $("#easy-start-linux").hide();
        $("#easy-start-windows").show();
    });

    $("#easy-start-linux-btn").on('click', function(){
        $("#easy-start-windows").hide();
        $("#easy-start-linux").show();
    });
  });

function handleGoToHub() {

    var lnk = $(".gotohub a.nav-link");

    if (lnk.length == 0) return;

    var hubUrl = pageInfo.hubUrl;

    var url = pageInfo.userName != null ? new URL("r/" + pageInfo.userName, hubUrl) : pageInfo.hubUrl;

    lnk.attr('href', url);
    lnk.attr('target', '_blank');

}

// Aggiunge la classe scrolled quando la pagina è scrollata e no-scroll quando non lo è
function handleNoScroll() {

    function checkScroll() {
        var scroll = $(window).scrollTop();

        var body = $("body");
        // Siamo al top
        if (scroll <= 0) {
            body.addClass('scroll-top');
            body.removeClass('scrolled');
        } else {
            body.removeClass('scroll-top');
            body.addClass('scrolled');
        }
    }

    checkScroll();

    $(window).on('scroll', function (event) {
        checkScroll();
    });
}

// Desktop menu hover indicator: a single bar (.nav-glider) glides to the hovered
// or focused item and rests under the current page item, if any
function setupNavGlider() {

    var container = document.getElementById('navbarDesktop');
    var menu = container && container.querySelector('.menu-nav');
    if (!menu) return;

    var links = menu.querySelectorAll(':scope > li > a.nav-link');
    if (links.length == 0) return;

    var glider = document.createElement('span');
    glider.className = 'nav-glider';
    glider.setAttribute('aria-hidden', 'true');
    container.appendChild(glider);

    var active = menu.querySelector(':scope > li.active > a.nav-link');
    var current = null;

    function moveTo(link) {
        current = link;

        if (!link || !container.offsetParent) {
            glider.classList.remove('is-visible');
            return;
        }

        var box = container.getBoundingClientRect();
        var rect = link.getBoundingClientRect();
        var style = window.getComputedStyle(link);
        var padLeft = parseFloat(style.paddingLeft);
        var padRight = parseFloat(style.paddingRight);

        // When hidden, appear in place instead of sliding from the last position
        if (!glider.classList.contains('is-visible'))
            glider.classList.add('no-slide');

        glider.style.setProperty('--glider-x', (rect.left - box.left + padLeft) + 'px');
        glider.style.setProperty('--glider-y', (rect.bottom - box.top - 4) + 'px');
        glider.style.setProperty('--glider-w', (rect.width - padLeft - padRight) + 'px');

        void glider.offsetWidth; // Apply the position before re-enabling the slide
        glider.classList.remove('no-slide');
        glider.classList.add('is-visible');
    }

    links.forEach(function (link) {
        link.addEventListener('mouseenter', function () { moveTo(link); });
        link.addEventListener('focus', function () { moveTo(link); });
    });

    // Items without a nav-link (the Login button) send the bar back to rest
    menu.querySelectorAll(':scope > li > :not(.nav-link)').forEach(function (el) {
        el.addEventListener('mouseenter', function () { moveTo(active); });
    });

    menu.addEventListener('mouseleave', function () { moveTo(active); });
    menu.addEventListener('focusout', function (e) {
        if (!menu.contains(e.relatedTarget)) moveTo(active);
    });

    window.addEventListener('resize', function () { moveTo(current); });
    if (document.fonts) document.fonts.ready.then(function () { moveTo(current); });

    moveTo(active);
}

// Scroll-linked animation of the homepage trust section: on 4 columns a line
// draws across the icons and lights each one as it passes; on narrower layouts
// every item reveals and lights from its own position in the viewport
function setupTrustScroll() {

    var section = document.querySelector('.trust-section');
    if (!section || !window.matchMedia || !window.requestAnimationFrame) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = section.querySelectorAll('.trust-item');
    var line = section.querySelector('.trust-line');
    var wide = window.matchMedia('(min-width: 992px)');
    var ticking = false;

    function clamp01(v) {
        return Math.max(0, Math.min(1, v));
    }

    function setItem(item, reveal, lit) {
        item.style.setProperty('--reveal', reveal.toFixed(4));
        item.classList.toggle('is-lit', lit);
    }

    function update() {
        ticking = false;

        var vh = window.innerHeight;

        if (wide.matches && line) {
            var rect = section.getBoundingClientRect();

            // 0 when the section enters the viewport, 1 when its centre reaches mid-screen
            var progress = clamp01((vh * 0.95 - rect.top) / (vh * 0.45 + rect.height / 2));
            var lineProgress = clamp01((progress - 0.2) / 0.7);
            var last = items.length - 1;

            line.style.setProperty('--line-progress', lineProgress.toFixed(4));

            for (var i = 0; i < items.length; i++) {
                setItem(items[i],
                    clamp01((progress - i * 0.1) / 0.35),
                    lineProgress > 0 && lineProgress >= i / last);
            }
        } else {
            for (var j = 0; j < items.length; j++) {
                var r = items[j].getBoundingClientRect();
                setItem(items[j],
                    clamp01((vh - r.top) / (vh * 0.35)),
                    r.top + r.height * 0.3 < vh * 0.7);
            }
        }
    }

    function requestUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
    }

    section.classList.add('is-scroll-linked');
    update();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
}

function clamp01(v) {
    return Math.max(0, Math.min(1, v));
}

// True when scroll-linked effects should run (they are skipped with reduced motion)
function canScrollLink() {
    return !!(window.matchMedia && window.requestAnimationFrame) &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// Runs update now and then at most once per frame on scroll and resize.
// Returns the function that schedules an update
function onScrollFrame(update) {
    var ticking = false;

    function request() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
            ticking = false;
            update();
        });
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();

    return request;
}

// 0 when the top of the element enters the bottom of the viewport,
// 1 once it has travelled the given share of the viewport height
function enterProgress(el, span) {
    var vh = window.innerHeight;
    return clamp01((vh - el.getBoundingClientRect().top) / (vh * span));
}

// Scroll-linked entrance of the homepage capabilities section: drives
// --cap-head, --cap-tabs and --cap-card (see front-page.scss). Measures the
// untransformed containers so the animated children do not feed back
function setupCapabilitiesScroll() {

    var section = document.querySelector('.capabilities-section');
    if (!section || !canScrollLink()) return;

    var header = section.querySelector('.section-header');
    var tabs = section.querySelector('.capability-tabs');
    if (!header || !tabs) return;

    onScrollFrame(function () {
        var content = section.querySelector('.capability-content.active');

        var head = enterProgress(header, 0.35);
        var tab = enterProgress(tabs, 0.3);
        var card = content ? enterProgress(content, 0.55) : 1;

        section.style.setProperty('--cap-head', head.toFixed(4));
        section.style.setProperty('--cap-tabs', tab.toFixed(4));
        section.style.setProperty('--cap-card', card.toFixed(4));
    });
}

// Scroll-linked "survey" reveal of the homepage showcase cards: each card
// enters from its column side, in a diagonal wave, then a scan line uncovers
// its image (see front-page.scss). Plays once: progress never goes backwards
function setupShowcaseScroll() {

    var grid = document.querySelector('.showcase-section .showcase-grid');
    if (!grid || !canScrollLink()) return;

    var items = grid.querySelectorAll('.showcase-item');
    if (items.length == 0) return;

    var slots = [];
    var progress = [];   // Furthest progress reached by each card
    var finished = 0;

    for (var k = 0; k < items.length; k++)
        progress.push(-Infinity);

    // Layout positions inside the grid; offsets ignore the animated transforms
    function measure() {
        var firstTop = items[0].offsetTop;
        var cols = 0;

        for (var i = 0; i < items.length && items[i].offsetTop == firstTop; i++)
            cols++;

        slots = [];

        for (var j = 0; j < items.length; j++) {
            var col = j % cols;
            slots.push({ top: items[j].offsetTop, col: col });
            items[j].style.setProperty('--dir', cols > 1 ? (col / (cols - 1) * 2 - 1).toFixed(2) : '0');
        }
    }

    function update() {
        if (finished == items.length) return;

        var vh = window.innerHeight;
        var gridTop = grid.getBoundingClientRect().top;

        for (var i = 0; i < items.length; i++) {
            // 0 when the card top reaches the bottom of the viewport, 1 at mid-screen
            var p = (vh - (gridTop + slots[i].top)) / (vh * 0.5) - slots[i].col * 0.12;
            if (p <= progress[i] || progress[i] >= 0.9) continue;

            progress[i] = p;
            var scan = clamp01((p - 0.3) / 0.6);

            items[i].style.setProperty('--enter', clamp01(p / 0.6).toFixed(4));
            items[i].style.setProperty('--scan', scan.toFixed(4));

            if (scan >= 1) {
                items[i].classList.add('is-scanned');
                finished++;
            }
        }
    }

    measure();
    var request = onScrollFrame(update);

    if (window.ResizeObserver) {
        new ResizeObserver(function () {
            measure();
            request();
        }).observe(grid);
    }
}

var delay = 300;
var inAnimation = "fadeInUp";
var outAnimation = "fadeOutUp";
var errAnimation = "fadeInRight";

function smartFbq(event, value) {
    if (typeof fbq !== 'undefined')
        fbq(event, value);
}

function log(text) {
    if (pageInfo.debug) {
        if (typeof console !== 'undefined' && typeof console.log !== 'undefined')
            console.log(text);
    }
}

function setupSingleWaypoint(selector, offset) {
    setupSingleWaypointWithClass(selector, offset, 'on-view');
}

function setupSingleWaypointWithClass(selector, offset, className, hideIt, keepOnTrigger) {

    if (typeof keepOnTrigger === 'undefined')
        keepOnTrigger = false;

    if (isEmpty(selector))
        throw 'Selector is empty';

    if (isEmpty(offset))
        throw 'Offset is empty';

    if (isEmpty(className))
        throw 'ClassName is empty';

    if (typeof hideIt === 'undefined')
        hideIt = false;

    if (hideIt) {
        $(selector).css('opacity', '0');
    }

    $(selector).waypoint({
        handler: function() {
            $(this.element).addClass(className);
            if (!keepOnTrigger)
                this.destroy();
        },
        offset: offset
    });
}

function isEmpty(param) {
    return (typeof param === "undefined") || param === null || param === '';
}

function getParameters(classNames) {

    var classes = classNames.split(/\s+/);

    for (var i = 0; i < classes.length; i++) {

        var cls = classes[i];

        if (cls.startsWith('animate-')) {

            var params = cls.split('-');

            if (params.length != 3) {
                log('Found invalid class: ' + cls);
                continue;
            }

            var offset = params[1] + '%';
            var animationClass = params[2];

            return { offset: offset, animationClass: animationClass, keepOnTrigger: false };
        }
    }

    return null;
}

// animate-{percent}-{animationClass}

function handleWaypoint(ts, parameters) {

    return function() {

        $(ts.element).addClass(parameters.animationClass);

        if (!parameters.keepOnTrigger)
            ts.destroy();
    };
}

function setupScrollAnimations() {
    var elements = $("[class^='animate-'],[class*=' animate-']");

    for (var n = 0; n < elements.length; n++) {

        var elem = elements[n];

        var parameters = getParameters(elem.className);
        //log(parameters);

        if (parameters == null) continue;

        $(elem).css('opacity', '0').addClass('animated').waypoint({
            handler: (function() {

                //var ts = this;
                var parms = parameters;

                return function() {

                    $(this.element).addClass(parms.animationClass);

                    if (!parms.keepOnTrigger)
                        this.destroy();
                };
            })(),
            offset: parameters.offset
        });
    }
}


function handleDebugParameter() {
    if (getParameterByName('debug') == "1") {
        pageInfo.debug = true;
        $("#viewport-helper").show();
    } else {
        pageInfo.debug = false;
    }
}

function handleNbParameter() {
    // The nb parameter, if present, clears the back history
    if (getParameterByName('nb') == "1") {
        window.history.replaceState(null, null, window.location.pathname);
    }
}

/**
 * Detect the current active responsive breakpoint in Bootstrap
 * @returns {string}
 * @author farside {@link https://stackoverflow.com/users/4354249/farside}
 */
function getResponsiveBreakpoint() {
    var envs = {
        xs: "d-none",
        sm: "d-sm-none",
        md: "d-md-none",
        lg: "d-lg-none",
        xl: "d-xl-none"
    };
    var env = "";

    var $el = $("<div>");
    $el.appendTo($("body"));

    for (var i = Object.keys(envs).length - 1; i >= 0; i--) {
        env = Object.keys(envs)[i];
        $el.addClass(envs[env]);
        if ($el.is(":hidden")) {
            break; // env detected
        }
    }
    $el.remove();
    return env;
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getScroll() {
    if (window.pageYOffset != undefined) {
        return { x: pageXOffset, y: pageYOffset };
    } else {
        var sx, sy, d = document,
            r = d.documentElement,
            b = d.body;
        sx = r.scrollLeft || b.scrollLeft || 0;
        sy = r.scrollTop || b.scrollTop || 0;
        return { x: sx, y: sy };
    }
}


function uuidv4() {
    if (typeof crypto !== 'undefined') {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(c) {
            return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
    } else {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function setItemWithExpiry(key, value, ttl) {
    const now = new Date();

    // Create an object containing the original value and the expiry timestamp
    const item = {
        value: value,
        expiry: now.getTime() + ttl, // TTL in milliseconds
    };

    // Store the item as a JSON string
    localStorage.setItem(key, JSON.stringify(item));
}

function getItemWithExpiry(key) {
    const itemStr = localStorage.getItem(key);

    // If the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    // Parse the JSON string back to an object
    const item = JSON.parse(itemStr);
    const now = new Date();

    // Check if the item has expired
    if (now.getTime() > item.expiry) {
        // Remove the item from storage
        localStorage.removeItem(key);
        return null;
    }

    // Return the original value
    return item.value;
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-webpalpha-webpanimation-webplossless_webp_lossless-setclasses !*/
! function(A, e, n) {
    function a(A, e) { return typeof A === e }

    function o() {
        var A, e, n, o, s, i, r;
        for (var f in l)
            if (l.hasOwnProperty(f)) {
                if (A = [], e = l[f], e.name && (A.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length))
                    for (n = 0; n < e.options.aliases.length; n++) A.push(e.options.aliases[n].toLowerCase());
                for (o = a(e.fn, "function") ? e.fn() : e.fn, s = 0; s < A.length; s++) i = A[s], r = i.split("."), 1 === r.length ? Modernizr[r[0]] = o : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = o), t.push((o ? "" : "no-") + r.join("-"))
            }
    }

    function s(A) {
        var e = c.className,
            n = Modernizr._config.classPrefix || "";
        if (u && (e = e.baseVal), Modernizr._config.enableJSClass) {
            var a = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            e = e.replace(a, "$1" + n + "js$2")
        }
        Modernizr._config.enableClasses && (e += " " + n + A.join(" " + n), u ? c.className.baseVal = e : c.className = e)
    }

    function i(A, e) {
        if ("object" == typeof A)
            for (var n in A) f(A, n) && i(n, A[n]);
        else {
            A = A.toLowerCase();
            var a = A.split("."),
                o = Modernizr[a[0]];
            if (2 == a.length && (o = o[a[1]]), "undefined" != typeof o) return Modernizr;
            e = "function" == typeof e ? e() : e, 1 == a.length ? Modernizr[a[0]] = e : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = e), s([(e && 0 != e ? "" : "no-") + a.join("-")]), Modernizr._trigger(A, e)
        }
        return Modernizr
    }
    var t = [],
        l = [],
        r = {
            _version: "3.6.0",
            _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
            _q: [],
            on: function(A, e) {
                var n = this;
                setTimeout(function() { e(n[A]) }, 0)
            },
            addTest: function(A, e, n) { l.push({ name: A, fn: e, options: n }) },
            addAsyncTest: function(A) { l.push({ name: null, fn: A }) }
        },
        Modernizr = function() {};
    Modernizr.prototype = r, Modernizr = new Modernizr;
    var f, c = e.documentElement,
        u = "svg" === c.nodeName.toLowerCase();
    ! function() {
        var A = {}.hasOwnProperty;
        f = a(A, "undefined") || a(A.call, "undefined") ? function(A, e) { return e in A && a(A.constructor.prototype[e], "undefined") } : function(e, n) { return A.call(e, n) }
    }(), r._l = {}, r.on = function(A, e) { this._l[A] || (this._l[A] = []), this._l[A].push(e), Modernizr.hasOwnProperty(A) && setTimeout(function() { Modernizr._trigger(A, Modernizr[A]) }, 0) }, r._trigger = function(A, e) {
        if (this._l[A]) {
            var n = this._l[A];
            setTimeout(function() { var A, a; for (A = 0; A < n.length; A++)(a = n[A])(e) }, 0), delete this._l[A]
        }
    }, Modernizr._q.push(function() { r.addTest = i }), Modernizr.addAsyncTest(function() {
        var A = new Image;
        A.onerror = function() { i("webpalpha", !1, { aliases: ["webp-alpha"] }) }, A.onload = function() { i("webpalpha", 1 == A.width, { aliases: ["webp-alpha"] }) }, A.src = "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="
    }), Modernizr.addAsyncTest(function() {
        var A = new Image;
        A.onerror = function() { i("webplossless", !1, { aliases: ["webp-lossless"] }) }, A.onload = function() { i("webplossless", 1 == A.width, { aliases: ["webp-lossless"] }) }, A.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="
    }), Modernizr.addAsyncTest(function() {
        function A(A, e, n) {
            function a(e) {
                var a = e && "load" === e.type ? 1 == o.width : !1,
                    s = "webp" === A;
                i(A, s && a ? new Boolean(a) : a), n && n(e)
            }
            var o = new Image;
            o.onerror = a, o.onload = a, o.src = e
        }
        var e = [{ uri: "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=", name: "webp" }, { uri: "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==", name: "webp.alpha" }, { uri: "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA", name: "webp.animation" }, { uri: "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=", name: "webp.lossless" }],
            n = e.shift();
        A(n.name, n.uri, function(n) {
            if (n && "load" === n.type)
                for (var a = 0; a < e.length; a++) A(e[a].name, e[a].uri)
        })
    }), Modernizr.addAsyncTest(function() {
        var A = new Image;
        A.onerror = function() { i("webpanimation", !1, { aliases: ["webp-animation"] }) }, A.onload = function() { i("webpanimation", 1 == A.width, { aliases: ["webp-animation"] }) }, A.src = "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    }), o(), s(t), delete r.addTest, delete r.addAsyncTest;
    for (var p = 0; p < Modernizr._q.length; p++) Modernizr._q[p]();
    A.Modernizr = Modernizr
}(window, document);

function copyEvent(id){
    var str = document.getElementById(id);
    window.getSelection().selectAllChildren(str);
    document.execCommand("Copy");
}

// Copy share option to clipboard with visual feedback
function copyShareOption(button) {
    var inputGroup = button.closest('.share-option-input-group');
    var input = inputGroup.querySelector('.share-option-input');
    var textToCopy = input.value;

    // Use modern clipboard API if available
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(function() {
            showCopyFeedback(button);
        }).catch(function() {
            fallbackCopy(input, button);
        });
    } else {
        fallbackCopy(input, button);
    }
}

function fallbackCopy(input, button) {
    input.select();
    input.setSelectionRange(0, 99999);
    document.execCommand('copy');
    showCopyFeedback(button);
}

function showCopyFeedback(button) {
    var icon = button.querySelector('i');
    var originalClass = icon.className;

    // Change to check icon
    icon.className = 'fas fa-check';
    button.classList.add('copied');

    // Revert after 2 seconds
    setTimeout(function() {
        icon.className = originalClass;
        button.classList.remove('copied');
    }, 2000);
}

var clip = function(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  };